import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PlaidProvider } from "./context/PlaidContext";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <PlaidProvider>
      <App />
    </PlaidProvider>
  </BrowserRouter>
);